export default [{
		path: 'practice',
		component: () => import('../../../views/platform/practice/home'),
		children: [{
			path: 'questions',
			component: () => import('../../../views/platform/practice/questions')
		}, {
			path: 'lookAnalysis',
			component: () => import('../../../views/platform/practice/lookAnalysis')
		}]
	},
	{
		path: 'unittesting',
		component: () => import('../../../views/platform/unittesting/home'),
		children: [{
			path: 'questions',
			component: () => import('../../../views/platform/unittesting/questions')
		}, {
			path: 'lookAnalysis',
			component: () => import('../../../views/platform/unittesting/lookAnalysis')
		}]
	},
	{
		path: 'qbank',
		component: () => import('../../../views/platform/questionBanks/home'),
		meta: {
			title: '题库'
		},
		children: [{
			path: 'transferStation',
			component: () => import('../../../views/platform/questionBanks/transferStation'),
			meta: {
				title: '题库'
			}
		}, {
			path: 'questions',
			component: () => import('../../../views/platform/questionBanks/questions'),
			meta: {
				title: '题库-试题练习'
			}
		}]
	}
]